/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/fighter_3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M16.75 13h-.375v-3h-.75v3h-.375v1.5L13 21.25h2.25V22h1.5v-.75H19l-2.25-6.75V13zm-.375 8.25h-.75V14.5h.75v6.75zM19 19v3h.75v-3zM12.25 19v3H13v-3z"/>'
  }
})
